<template>
	<el-drawer :title="data ? '编辑演出' : '新增演出'" :visible.sync="drawerShow" :wrapperClosable="false"
		:destroy-on-close="true" size="auto" @close="close" append-to-body>
		<div class="drawer-content">
			<el-form :model="formData" ref="formData" label-position="top" size="medium" :rules="rules">

				<el-form-item label="选择演出:">
					<span slot="label">选择演出：<small class="from-tip"><span
								class="el-icon-warning"></span>填写演出ID，多个ID之间用逗号分隔</small></span>
					<el-input placeholder="请输入演出ID" v-model="sActivityIds">
						<el-button slot="append" icon="el-icon-search" @click="searchActivity()">搜索演出</el-button>
					</el-input>
					<el-table class="MT10 sortable-table" :data="sActivityList" size="medium" border stripe
						v-loading="sActivityLoading" row-key="id">
						<el-table-column prop="id" label="演出ID" width="90"></el-table-column>
						<el-table-column prop="name" label="演出名称" show-overflow-tooltip
							min-width="150"></el-table-column>
						<el-table-column label="选择场次/票品" width="400">
							<template slot-scope="scope">
								<el-cascader v-model="scope.row.ids" :options="scope.row.sessions"
									:props="{value:'id',label:'name',children:'tickets',multiple: true, checkStrictly: true }"
									size="small" style="width:300px" clearable></el-cascader>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="80">
							<template slot-scope="scope">
								<el-button type="text" @click="delActivity(scope.row.id)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
				<el-form-item prop="dashboardTitle" label="看板名称：">
					<el-input v-model.trim="formData.dashboardTitle" placeholder="请填写看板名称"></el-input>
				</el-form-item>
				<el-form-item prop="beginTime">
					<span slot="label">看板开启时间：<small class="from-tip color-warning"><span
								class="el-icon-warning"></span> 默认演出开始前8小时</small></span>
					<el-input-number style="width:100%" v-model="formData.beginTime" :precision="0"
						controls-position="right" :min="0.00" :max="99999999.99" size="medium"
						placeholder="请填写看板开启时间"></el-input-number>
				</el-form-item>
				<el-form-item prop="expTime">
					<span slot="label">看板结束时间：<small class="from-tip color-warning"><span
								class="el-icon-warning"></span> 默认演出结束后8小时</small></span>
					<el-input-number style="width:100%" v-model="formData.expTime" :precision="0"
						controls-position="right" :min="0.00" :max="99999999.99" size="medium"
						placeholder="请填写看板结束时间"></el-input-number>
				</el-form-item>
				<el-form-item prop="checkTime" label="核销开始时间:">
					<span slot="label">核销开始时间：<small class="from-tip color-warning"><span
								class="el-icon-warning"></span> 默认演出开始前4小时</small></span>
					<el-input-number style="width:100%" v-model="formData.checkTime" :precision="0"
						controls-position="right" :min="0.00" :max="99999999.99" size="medium"
						placeholder="请填写核销开始时间"></el-input-number>
				</el-form-item>

				<el-form-item v-if="data && data.pw">
					<span slot="label">当前密码: {{data.pw}}</span>
				</el-form-item>
				<el-form-item prop="pw" label="设置密码:">
					<el-input v-model="formData.pw" placeholder="请填写密码" :minlength="6"></el-input>
				</el-form-item>
				<el-form-item prop="openDashboard2" label='“看板2”开关:'>
					<el-switch v-model="formData.openDashboard2" :active-value="1" :inactive-value="0"></el-switch>
					{{ formData.openDashboard2 == 1 ? "已开启" : "已关闭"}}
				</el-form-item>
				<el-form-item prop="frequency" label='是否高频处理数据:'>
					<span slot="label">是否高频处理数据：<small class="from-tip color-warning"><span
								class="el-icon-warning"></span> 设置高频处理可能会导致看板数据比实际值多一点</small></span>
					<el-switch v-model="formData.frequency" :active-value="1" :inactive-value="0"></el-switch>
					{{ formData.frequency == 1 ? "已开启" : "已关闭" }}
				</el-form-item>
			</el-form>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">取 消</el-button>
			<el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
		</div>
	</el-drawer>
</template>

<script>
	const defaultFormData = {
		dashboardTitle: "",
		pw: "",
		openDashboard2: 1,
		beginTime: 8,
		expTime: 8,
		checkTime: 4,
		frequency: 0,
	}
	export default {
		data() {
			var checkPw = (rule, value, callback) => {
				if (value && value.length < 6) {
					return callback(new Error('至少输入6位'));
				} else {
					callback();
				}
			};
			return {
				drawerShow: false,
				btnLoading: false,
				formData: {
					...defaultFormData
				},
				rules: {
					pw: [
						{
							validator: checkPw
						}
					]
				},
				data: null,

				sActivityIds: "",
				sActivityLoading: false,
				sActivityList: [],

			}
		},
		methods: {
			show(data) {
				this.data = data || null;
				this.formData = {
					...defaultFormData,
					openDashboard2: data ? data.openDashboard2 : 1,
					id:data ? data.id : '',
					dashboardTitle:data ? data.dashboardTitle : '',
					beginTime:data ? data.beginTime : '',
					expTime:data ? data.expTime : '',
					checkTime:data ? data.checkTime : '',
					frequency:data ? data.frequency : 0,
				}
				if (this.$refs.formData) {
					this.$refs.formData.clearValidate();
				}
				this.sActivityIds = this.data ? this.data.activityId : '';
				var dataArray = []
				if (this.data && this.data.dataList.length > 0) {
					dataArray = this.data.dataList.map(item => {
						return {
							...item,
							ids: []
						};
					});
				}
				
				if (this.sActivityIds) {
					this.searchActivity(() => {
						this.$nextTick(() => {
							dataArray.forEach((item, index) => {
								if( item.sessions && item.sessions.length > 0 ){
									item.sessions.forEach((items, indexs) => {
										if (!items.priceId) {
											item.ids.push([items.sessionId]);
										} else {
											items.priceId.forEach(priceId => {
												item.ids.push([items.sessionId,
													priceId
												]);
											})
										}
									})
								}
								
							})

							
							var dataArray2 = []
							dataArray2 = this.sActivityList.map(item => {
								return {
									...item,
									ids: []
								};
							});
							
							dataArray2.map((i, v) => {

								dataArray2[v].ids = dataArray[v].ids;
							});
							this.sActivityList = dataArray2
							
						})
					});
				}

				this.drawerShow = true;
			},
			close() {
				if (this.$refs.formData) {
					// this.$refs.formData.resetFields();
					this.$refs.formData.clearValidate();
				}
				this.sActivityIds = ''
				this.sActivityList = []
				this.drawerShow = false;
			},
			
			//搜索演出
			
			async searchActivity(callback) {
				this.sActivityList = []
				if (this.sActivityIds) {
					this.sActivityLoading = true;

					this.sActivityIds = this.sActivityIds.replace(/，/g, ',');

					let _sActivityIds = this.sActivityIds.split(',');
					_sActivityIds.map((v, i) => _sActivityIds[i] = parseInt(v));

					const res = await this.$request({
						url: '/daping/activitySelect',
						method: 'post',
						data: _sActivityIds
					}).catch(() => {
						return {
							data: {
								state: '0',
								msg: '请求错误'
							}
						};
					}).finally(() => {
						this.sActivityLoading = false;
					});

					const {
						state,
						msg,
						result
					} = res.data;

					if (state != 1) {
						return this.$message.error(msg || '请求失败');

					} else {
						if (result && result.length > 0) {

							result.map(item => {
								if (!this.sActivityList.find(v => v.id == item.id)) {
									this.sActivityList.push(item)
								} 
							})

							callback && callback();


						} else {
							this.$message.error(msg || '没有找到相关演出');
						}
					}
				}
			},
			//删除演出
			delActivity(id) {
			    this.sActivityList = this.sActivityList.filter(v => v.id != id);
			},
			submitForm() {
				
				
				var dataList = []
				if( this.formData && !this.formData.id && this.formData.pw == '' ){
					return this.$message.warning('密码不能为空！');
				}
				if (this.sActivityList && this.sActivityList.length == 0) {
					return this.$message.warning('请先添加演出！');
				} 
				
				// 遍历原始数据
				this.sActivityList.forEach((item, index) => {
					
					const sessions = []
					const groupedData = {};
					
					if( item.ids && item.ids.length > 0 ){
						
						item.ids.forEach(idArray => {
						
						
						if (idArray.length === 1) {
						        // 长度为1的单独生成sessionId对象
						        sessions.push({
						          sessionId: idArray[0]
						        });
						      } else if (idArray.length === 2) {
						        // 长度为2的按sessionId分组
						        const sessionId = idArray[0];
						        const priceId = idArray[1];
						        
						        if (!groupedData[sessionId]) {
						          groupedData[sessionId] = {
						            sessionId: sessionId,
						            priceId: []
						          };
						        }
						        groupedData[sessionId].priceId.push(priceId);
						      }
							
						
						})
						
						// 将分组后的数据添加到结果中
						    Object.values(groupedData).forEach(group => {
						      sessions.push(group);
						    });
						
						dataList.push({
							activityId: item.id,
							sessions: sessions
						})
					}else{
						dataList.push({
							activityId: item.id
							})
						}
						
				})
				
				this.$refs["formData"].validate(async (valid) => {
					if (valid) {
						this.btnLoading = true;
						this.$request({
								url: '/daping/pw/save',
								data: {
									...this.formData,
									dataList: dataList,
									pw: this.formData.pw || this.data && this.data.pw || this.formData
										.sessionId
								},
								method: "post",
							})
							.then((res) => {
								const {
									state,
									msg
								} = res.data;
								if (state == 1) {
									this.$emit('onUpdate');
									this.close();
								} else {
									this.$message.error(msg || "操作失败,请重试");
								}
							})
							.catch(() => {
								this.$message.error("操作失败,请重试");
							})
							.finally(() => {
								this.btnLoading = false;
							});
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-form-item__label small {
		color: #E6A23C
	}
</style>